export default function CornemuseIcon({ className = "h-5 w-5" }) {
  // Dessin de cornemuse réalisé par le groupe (/public/cornemuse.png).
  // Utilisé en masque CSS : la silhouette prend automatiquement la couleur du texte environnant.
  return (
    <span
      aria-hidden="true"
      className={`inline-block shrink-0 bg-current ${className}`}
      style={{
        WebkitMaskImage: "url(/cornemuse.png)",
        maskImage: "url(/cornemuse.png)",
        WebkitMaskSize: "contain",
        maskSize: "contain",
        WebkitMaskPosition: "center",
        maskPosition: "center",
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
      }}
    />
  );
}
